import { Playlist } from '../api';

/**
 * Checks if a source has a valid playlist URL.
 * Used to determine if the player should (re)initialize based on playlist presence.
 */
export const hasPlaylistUrl = (src: Playlist | string | undefined): boolean => {
  if (!src) return false;
  if (typeof src === 'string') return true;

  return !!(
    src.url ||
    src.drm?.widevine?.playlistUrl ||
    src.drm?.playready?.playlistUrl ||
    src.drm?.fairplay?.playlistUrl
  );
};
